import React from "react";
import { Pressable, Text, View } from "react-native";

import { useAIExhibitFixedNarration } from "../audio/useAIExhibitFixedNarration";
import { AI_EXHIBIT_COLORS as C } from "../aiExhibitTheme";

function InfoCard({ children, onPress, audioEnabled = false }) {
  const Card = onPress ? Pressable : View;

  return (
    <Card
      onPress={onPress}
      style={{
        flex: 1,
        minWidth: 320,
        padding: 22,
        borderRadius: 18,
        borderWidth: 1,
        borderColor: C.border,
        backgroundColor: C.surfaceRaised,
      }}
    >
      {audioEnabled ? (
        <Text
          accessibilityLabel="Play narration"
          style={{
            position: "absolute",
            top: 14,
            right: 16,
            color: C.accent,
            fontSize: 18,
          }}
        >
          🔊
        </Text>
      ) : null}

      {children}
    </Card>
  );
}

export default function WhatIsAIScreen({
  navigate,
  copy,
  language = "en",
  audioEnabled = false,
}) {
  const { playNarration } = useAIExhibitFixedNarration({
    audioEnabled,
    language,
  });

  return (
    <View style={{ padding: 28 }}>
      <Text
        style={{
          color: C.accent,
          fontSize: 13,
          fontWeight: "900",
          letterSpacing: 1.2,
        }}
      >
        {copy.whatIsAI.eyebrow}
      </Text>

      <Text
        style={{
          color: C.text,
          fontSize: 46,
          lineHeight: 52,
          fontWeight: "900",
          marginTop: 8,
        }}
      >
        {copy.whatIsAI.title}
      </Text>

      <View
        style={{
          flexDirection: "row",
          flexWrap: "wrap",
          gap: 16,
          marginTop: 28,
        }}
      >
        <InfoCard
          audioEnabled={audioEnabled}
          onPress={() => playNarration("what_is_ai_definition")}
        >
          <Text style={{ color: C.text, fontSize: 20, lineHeight: 31 }}>
            {copy.whatIsAI.definition}
          </Text>

          <Text
            style={{
              color: C.muted,
              fontSize: 15,
              lineHeight: 23,
              marginTop: 18,
            }}
          >
            {copy.whatIsAI.nuance}
          </Text>
        </InfoCard>

        <InfoCard
          audioEnabled={audioEnabled}
          onPress={() => playNarration("what_is_ai_not_automatically")}
        >
          <Text style={{ color: C.text, fontSize: 21, fontWeight: "900" }}>
            {copy.whatIsAI.notAutomatically}
          </Text>

          <View
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              gap: 10,
              marginTop: 18,
            }}
          >
            {copy.whatIsAI.notItems.map((item) => (
              <View
                key={item.id}
                style={{
                  width: "47%",
                  flexGrow: 1,
                  padding: 16,
                  borderRadius: 14,
                  borderWidth: 1,
                  borderColor: C.border,
                  backgroundColor: C.surface,
                }}
              >
                <Text
                  style={{
                    color: C.text,
                    fontSize: 17,
                    fontWeight: "800",
                    textAlign: "center",
                  }}
                >
                  {item.icon} {item.text}
                </Text>
              </View>
            ))}
          </View>
        </InfoCard>
      </View>

      <View
        style={{
          flexDirection: "row",
          flexWrap: "wrap",
          gap: 14,
          marginTop: 20,
        }}
      >
        {copy.whatIsAI.explore.map((item) => (
          <Pressable
            key={item.id}
            onPress={() => navigate(item.id)}
            style={({ pressed }) => ({
              flex: 1,
              minWidth: 260,
              padding: 20,
              minHeight: 120,
              borderRadius: 17,
              borderWidth: 1,
              borderColor: C.border,
              backgroundColor: pressed ? C.accentSoft : C.surfaceRaised,
            })}
          >
            <Text style={{ color: C.text, fontSize: 20, fontWeight: "900" }}>
              {item.title}
            </Text>

            <Text style={{ color: C.muted, fontSize: 15, marginTop: 7 }}>
              {item.subtitle}
            </Text>
          </Pressable>
        ))}
      </View>
    </View>
  );
}
